module.exports = __webpack_public_path__ + "static/media/fa-check.63409e17.svg";